/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import JobLists from "components/Joblistings/JobLists";
import Login from "layouts/authentication/sign-in";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser, setUserPhoto } from "./../../Redux/action/sessionAction";
import { Link } from "react-router-dom";
import axios from "axios";

// import { multiStepContext } from "../../stepContext";
function Dashboard() {
  const dispatch = useDispatch();
  const sessionId = useSelector((state) => state.session.sessionId || null);
  const user_id = useSelector((state) =>
    state.session.setUserId ? state.session.setUserId.value : null
  );
  const { sales, tasks } = reportsLineChartData;
  // const { handleClose, handleOpen } = useContext(multiStepContext);
  const [open, setOpen] = useState(false);

  const handleModalOpen = () => {
    setOpen(true);
    handleOpen();
  };

  // Handle modal close
  const handleModalClose = () => {
    setOpen(false);
    handleClose();
  };

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/service/v4_1/rest.php";
      const method = "get_entry_list";
      const input_type = "JSON";
      const response_type = "JSON";
      const rest_data = JSON.stringify({
        session: sessionId,
        module_name: "Users",
        // select_fields: [
        //   "id",
        //   "name",
        //   "user_name",
        //   "first_name",
        //   "last_name",
        //   "email_c",
        //   "phone_mobile",
        //   "aadhar",
        //   "address_street",
        //   "address_state",
        //   "address_country",
        //   "address_city",
        //   "referrer_c",
        //   "selfdescription_c",
        //   "dob_c",
        //   "address_postalcode",
        // ],
      });

      const fullUrl = `${apiUrl}?method=${method}&input_type=${input_type}&response_type=${response_type}&rest_data=${encodeURIComponent(
        rest_data
      )}`;

      try {
        const response = await axios.get(fullUrl);
        if (response.data.name === "Invalid Session ID") {
          navigate("/authentication/sign-in");
        }
        const entryList = response.data.entry_list;
        const products = entryList.map((entry) => entry.name_value_list);
        const filteredProfiles = products.filter((item) => item.id.value === user_id);
        const profileData = filteredProfiles.length > 0 ? filteredProfiles[0] : null;
        const user = dispatch(setUser(profileData));

        const storedFamilyGroupId = localStorage.getItem("familyGroupId");
        const profileFamilyGroupId = profileData?.family_group_id_c?.value || profileData?.family_group_id_c;
        if (!storedFamilyGroupId && profileFamilyGroupId) {
          localStorage.setItem("familyGroupId", String(profileFamilyGroupId));
        }

        console.log(user);
      } catch (error) {
        if (error.response) {
          console.error("An error occurred during get data:", error.response.data);
        } else if (error.request) {
          console.error("No response received:", error.request);
        } else {
          console.error("Error setting up request:", error.message);
        }
      }
    };

    if (sessionId) {
      fetchData();
    }
  }, [sessionId, user_id]);

  const callSuiteCrmApi = async (method, data, retries = 2) => {
    const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/service/v4_1/rest.php";

    const params = new URLSearchParams();
    params.append("method", method);
    params.append("input_type", "JSON");
    params.append("response_type", "JSON");
    params.append("rest_data", JSON.stringify(data));

    try {
      const response = await axios.post(apiUrl, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      return response.data;
    } catch (error) {
      if (retries > 0) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return callSuiteCrmApi(method, data, retries - 1);
      }
      throw error;
    }
  };

  // Fetch profile image on component mount
  useEffect(() => {
    const fetchProfileImage = async () => {
      if (!sessionId || !user_id) return;

      try {
        const searchData = {
          session: sessionId,
          module_name: "Notes",
          query: `notes.parent_id = '${user_id}' AND notes.name = 'Profile Photo'`,
          order_by: "",
          offset: 0,
          select_fields: ["id"],
          max_results: 1,
        };

        const existingNote = await callSuiteCrmApi("get_entry_list", searchData);

        if (existingNote.entry_list && existingNote.entry_list.length > 0) {
          const noteId = existingNote.entry_list[0].id;
          const attachmentData = {
            session: sessionId,
            id: noteId,
          };

          const response = await callSuiteCrmApi("get_note_attachment", attachmentData);

          console.log("image", response)
          if (response?.note_attachment?.file) {
           const userPhoto = dispatch(
              setUserPhoto(
                `data:${response.note_attachment.file_mime_type};base64,${response.note_attachment.file}`
              )
            );
            // console.log(userPhoto)
          }
        }
      } catch (error) {
        console.error("Error fetching profile image:", error);
      }
    };

    fetchProfileImage();
  }, [sessionId, user_id]);

  return (
    <>
      {!sessionId ? (
        <Login />
      ) : (
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox py={{ xs: 2, sm: 3 }} px={{ xs: 2, sm: 3, md: 4 }}>
            {/* Welcome Section */}
            <MDBox 
              mb={{ xs: 3, sm: 4 }}
              p={{ xs: 2, sm: 3 }}
              sx={{
                background: "linear-gradient(195deg, #42424a 0%, #191919 100%)",
                borderRadius: "1rem",
                boxShadow: "0 4px 20px 0 rgba(0,0,0,0.14)",
                color: "#fff"
              }}
            >
              <MDBox 
                component="h2" 
                sx={{ 
                  fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                  fontWeight: 600,
                  mb: 1,
                  color: "#fff"
                }}
              >
                Welcome to Moona Consultancy Portal
              </MDBox>
              <MDBox 
                component="p" 
                sx={{ 
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  opacity: 0.9,
                  mb: 0,
                  color: "#fff"
                }}
              >
                Manage your family tree, explore job opportunities, and view your business network.
              </MDBox>
            </MDBox>

            {/* Navigation Cards */}
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              <Grid item xs={12} sm={6} lg={4}>
                <Link to="/familyTree" style={{ textDecoration: "none" }}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #3b82f6 0%, #1e40af 100%)",
                      borderRadius: "1rem",
                      p: { xs: 2.5, sm: 3 },
                      color: "#fff",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 20px 0 rgba(59, 130, 246, 0.3)",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 8px 30px 0 rgba(59, 130, 246, 0.4)"
                      }
                    }}
                  >
                    <MDBox display="flex" alignItems="center" mb={1.5}>
                      <MDBox
                        sx={{
                          width: { xs: 40, sm: 48 },
                          height: { xs: 40, sm: 48 },
                          borderRadius: "0.75rem",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: { xs: "1.5rem", sm: "1.75rem" }
                        }}
                      >
                        👨‍👩‍👧‍👦
                      </MDBox>
                    </MDBox>
                    <MDBox 
                      component="h3" 
                      sx={{ 
                        fontSize: { xs: "1.125rem", sm: "1.25rem" },
                        fontWeight: 600,
                        mb: 0.5,
                        color: "#fff"
                      }}
                    >
                      Family Tree
                    </MDBox>
                    <MDBox 
                      component="p" 
                      sx={{ 
                        fontSize: { xs: "0.8125rem", sm: "0.875rem" },
                        opacity: 0.9,
                        mb: 0,
                        color: "#fff"
                      }}
                    >
                      Visualize and manage your family relationships
                    </MDBox>
                  </MDBox>
                </Link>
              </Grid>

              <Grid item xs={12} sm={6} lg={4}>
                <Link to="/jobListing" style={{ textDecoration: "none" }}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #ec4899 0%, #be185d 100%)",
                      borderRadius: "1rem",
                      p: { xs: 2.5, sm: 3 },
                      color: "#fff",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 20px 0 rgba(236, 72, 153, 0.3)",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 8px 30px 0 rgba(236, 72, 153, 0.4)"
                      }
                    }}
                  >
                    <MDBox display="flex" alignItems="center" mb={1.5}>
                      <MDBox
                        sx={{
                          width: { xs: 40, sm: 48 },
                          height: { xs: 40, sm: 48 },
                          borderRadius: "0.75rem",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: { xs: "1.5rem", sm: "1.75rem" }
                        }}
                      >
                        💼
                      </MDBox>
                    </MDBox>
                    <MDBox 
                      component="h3" 
                      sx={{ 
                        fontSize: { xs: "1.125rem", sm: "1.25rem" },
                        fontWeight: 600,
                        mb: 0.5,
                        color: "#fff"
                      }}
                    >
                      Job Listing
                    </MDBox>
                    <MDBox 
                      component="p" 
                      sx={{ 
                        fontSize: { xs: "0.8125rem", sm: "0.875rem" },
                        opacity: 0.9,
                        mb: 0,
                        color: "#fff"
                      }}
                    >
                      Explore and apply for job opportunities
                    </MDBox>
                  </MDBox>
                </Link>
              </Grid>

              <Grid item xs={12} sm={6} lg={4}>
                <Link to="/treeview" style={{ textDecoration: "none" }}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #10b981 0%, #047857 100%)",
                      borderRadius: "1rem",
                      p: { xs: 2.5, sm: 3 },
                      color: "#fff",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 20px 0 rgba(16, 185, 129, 0.3)",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 8px 30px 0 rgba(16, 185, 129, 0.4)"
                      }
                    }}
                  >
                    <MDBox display="flex" alignItems="center" mb={1.5}>
                      <MDBox
                        sx={{
                          width: { xs: 40, sm: 48 },
                          height: { xs: 40, sm: 48 },
                          borderRadius: "0.75rem",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: { xs: "1.5rem", sm: "1.75rem" }
                        }}
                      >
                        🌳
                      </MDBox>
                    </MDBox>
                    <MDBox 
                      component="h3" 
                      sx={{ 
                        fontSize: { xs: "1.125rem", sm: "1.25rem" },
                        fontWeight: 600,
                        mb: 0.5,
                        color: "#fff"
                      }}
                    >
                      Business Tree View
                    </MDBox>
                    <MDBox 
                      component="p" 
                      sx={{ 
                        fontSize: { xs: "0.8125rem", sm: "0.875rem" },
                        opacity: 0.9,
                        mb: 0,
                        color: "#fff"
                      }}
                    >
                      View your business network structure
                    </MDBox>
                  </MDBox>
                </Link>
              </Grid>
            </Grid>
          </MDBox>
        </DashboardLayout>
      )}
    </>
  );
}

export default Dashboard;
